import { totalTransactionsChartOptions } from "../utils/data";
import ChartStatus from "components/common/ChartStatus/ChartStatus";
import ChartGraph from "utils/Charts/ChartGraph/ChartGraph";

const data = [
	{
		color: "#509FEF",
		value: 200,
		name: "Resolved Dispute",
		cls: "recent-blue-icon ",
	},
	{
		color: "#F1F7FE",
		value: 250,
		name: "UnResolved Dispute",
		cls: "recent-light-blue-icon ",
	},
];

const DisputeStatistics = () => {
	return (
		<div className="bg-white pt-4 my-5 h-100">
			<p className="title px-5">Dispute Statistics</p>
			<div className="flex__center">
				<ChartGraph
					option={totalTransactionsChartOptions(data)}
					styles={{
						height: "255px",
					}}
				/>
			</div>
			<div className="px-2 pb-3">
				{data.map(({ value, name, cls }) => (
					<ChartStatus value={value} name={name} cls={cls} />
				))}
			</div>
		</div>
	);
};

export default DisputeStatistics;
